import { addRoute } from "../shared/router.js";
import materialDesign3 from "./page.vue";

addRoute("/material-design-3", materialDesign3);
